module.exports = __webpack_public_path__ + "img/Superpagespr.com.03c85816.svg";